import React from 'react';
import { formatHour } from '../../utils/slotMath';

export function CalRow({
  calendar, events, slots, hoveredHour, onHoverHour, nowHour,
  onPillHover, onPillClick, hoveredEventNumber, clickedEventNumber,
  onSlotClick, meetingPickHours,
}) {
  return (
    <div className="wv-row wv-cal-row">
      <div className="wv-row-label">
        <div className="wv-row-label-title wv-cal-name">
          <span className="wv-cal-dot" style={{ backgroundColor: calendar.accent }} />
          {calendar.name}
        </div>
      </div>
      <div className="wv-timeline wv-timeline--cal">
        {slots.map((slot, i) => {
          const slotStart = slot.hour;
          const slotEnd = slot.hour + 1;
          const startsHere = events.filter(ev => ev.startHour >= slotStart && ev.startHour < slotEnd);
          const overlaps = events.some(ev => ev.startHour < slotEnd && ev.startHour + ev.durationHours > slotStart);
          // Cap drawn circles at 3 in the closed state. On hover, all of
          // them fan out so the user can see and click event #4+ too.
          const totalCount = startsHere.length;
          const visibleCount = Math.min(totalCount, 3);
          const isStack = totalCount > 1;
          return (
            <div
              key={i}
              className={`wv-slot wv-slot--cal${overlaps ? ' wv-slot--has-event' : ''}${nowHour === slot.hour ? ' wv-slot--now' : ''}${isStack ? ' wv-slot--stack' : ''}${meetingPickHours?.has(slot.hour) ? ' wv-slot--meeting-pick' : ''}`}
              onClick={onSlotClick ? (e) => onSlotClick(e, slot) : undefined}
              style={onSlotClick ? { cursor: 'pointer' } : undefined}
              onMouseEnter={onHoverHour ? () => onHoverHour(slot.hour) : undefined}
              onMouseLeave={onHoverHour ? () => onHoverHour(null) : undefined}
            >
              {totalCount > 0 && (
                <div
                  className="wv-event-stack"
                  data-count={totalCount}
                  style={{ '--wv-stack-total-n': totalCount }}
                >
                  {startsHere.map((ev, idx) => {
                    // In a stack, force every event into circle form so the
                    // fan-out animation reads cleanly. Solo events keep their
                    // duration-based pill.
                    const circle = isStack || ev.durationHours <= 1;
                    const isOverflow = idx >= visibleCount;
                    return (
                      <div
                        key={ev.id}
                        className={[
                          'wv-event-pill',
                          `wv-event-pill--${ev.status || 'accepted'}`,
                          circle ? 'wv-event-pill--circle' : '',
                          isStack ? 'wv-event-pill--stacked' : '',
                          isOverflow ? 'wv-event-pill--overflow' : '',
                          ev.sequentialNumber && hoveredEventNumber === ev.sequentialNumber ? 'wv-event-pill--highlighted' : '',
                          ev.sequentialNumber && clickedEventNumber === ev.sequentialNumber ? 'wv-event-pill--clicked' : '',
                        ].join(' ').trim()}
                        style={{
                          '--wv-event-color': calendar.accent,
                          '--wv-stack-i': idx,
                          '--wv-stack-n': visibleCount,
                          '--wv-stack-total-n': totalCount,
                          width: circle ? undefined : `calc(${ev.durationHours * 100}% - 6px)`,
                          zIndex: isStack ? 20 - idx : undefined,
                        }}
                        onMouseEnter={(e) => {
                          const r = e.currentTarget.getBoundingClientRect();
                          onPillHover && onPillHover({
                            content: `${ev.title}\n${formatHour(ev.startHour)} – ${formatHour(ev.startHour + ev.durationHours)}`,
                            x: r.left + r.width / 2,
                            y: r.top,
                          });
                        }}
                        onMouseLeave={() => onPillHover && onPillHover(null)}
                        onClick={() => onPillClick && onPillClick(ev.sequentialNumber)}
                      />
                    );
                  })}
                  {(isStack || totalCount > visibleCount) && (
                    <span className="wv-event-stack-count">{totalCount}</span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
